import { Dialog, Stack, Text, TextLink } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

const CreditScoreImpactDialog = ({ visible, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog
      id="creditScoreImpactDialog"
      title={t(
        'r.profile.edit.liv_score_credit_check.modal.title',
        'How does this impact my credit score?'
      )}
      open={visible}
      onClose={onClose}
    >
      <Stack space="large">
        <Text size="standard">
          {t(
            'r.profile.edit.liv-score-credit_check.modal.description.text',
            "The Trust Score gathers information from renters' Equifax® credit reports and will appear as an inquiry on their credit file. This will impact their overall credit score, however the impact will not be significant since the Trust Score is not an application for credit."
          )}
        </Text>
        <Text>
          {t(
            'r.profile.edit.liv-score-credit_check.modal.contact.text',
            'If you have any questions, please contact'
          )}{' '}
          <TextLink href="mailto:support@liv.rent">support@liv.rent</TextLink>.
        </Text>
      </Stack>
    </Dialog>
  )
}

export default CreditScoreImpactDialog
